import React from 'react'
import { Box } from '@material-ui/core'
import useStyles from './Styles'
import { IVimeoPlayer } from './Interface'

const VimeoPlayer: React.FC<IVimeoPlayer> = ({ width, height, videoId, allow }) => {
  const classes = useStyles({})

  return (
    <Box className={classes.playerContainer}>
      <iframe
        id={`${videoId}-vimeo-player-iframe`}
        className={classes.player}
        width={width}
        height={height}
        allow={allow}
        title="Vimeo Player"
        src={`https://player.vimeo.com/video/${videoId}`}
      ></iframe>
    </Box>
  )
}

VimeoPlayer.defaultProps = {
  width: 560,
  height: 315,
  allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'
}

export default VimeoPlayer
